/*
 *  Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React, { ReactNode } from "react";
import Container from "../../../../../../components/Container/Container";
import Grid from "@mui/material/Grid";
import { Box, Button, Stack } from "@mui/material";
import { wbsTeaserWithCardsStyles } from "./wbsTeaserWithCardsStyles";
import Typography from "@mui/material/Typography";
import { scrollToAnchor } from "../../../../../../theme/commonStyle";
import WbsLegalbird from "../../../../../../assets/img/landingpage/wbs/wbs_legalbird.svg";
import { gaEvent } from "../../../../../../services/googleAnalyticsService";
import { Link } from "react-router";

export interface WbsTeaserWithCardsProps {
  hasTeaserButton?: boolean;
  teaserButtonText?: string;
  teaserButtonLink?: string;
  teaserButtonType?: any;
  teaserButtonOnClick?: any;
  headline?: string;
  subHeadline?: string | React.ReactNode;
  children?: ReactNode;
}

const WbsTeaserWithCards = ({
  hasTeaserButton = true,
  teaserButtonText = "Jetzt kostenlos starten",
  teaserButtonLink = "#top-checkin",
  teaserButtonType = Link,
  teaserButtonOnClick = () => {},
  headline,
  subHeadline = "Wir helfen Ihnen einfach, schnell und professionell. Egal wann und wo!",
  children,
}: WbsTeaserWithCardsProps) => {
  const handleTeaserButtonClick = () => {
    gaEvent({
      category: "Button Click",
      action: "Teaser Start",
    });
    teaserButtonOnClick();
  };

  return (
    <div>
      <Container sectionPadding={false}>
        <Box sx={scrollToAnchor} id="jetzt-starten" />
        <Grid
          container
          wrap={"nowrap"}
          sx={[{
            alignContent: "center",
            alignItems: "center",
            justifyContent: "space-between"
          }, wbsTeaserWithCardsStyles.gridContainer]}>
          <Grid size={12}>
            <Stack direction={"row"} sx={{
              justifyContent: "center"
            }}>
              <img src={WbsLegalbird} alt={"WBS & Legalbird"} />
            </Stack>
            <Typography variant={"h1"} id="teaser-headline" sx={wbsTeaserWithCardsStyles.gridItemText}>
              {headline}
            </Typography>
            {subHeadline && (
              <Typography variant={"subtitle2"} id="teaser-subheadline" sx={wbsTeaserWithCardsStyles.gridItemText}>
                {subHeadline}
              </Typography>
            )}
            {hasTeaserButton && (
              <Box sx={wbsTeaserWithCardsStyles.buttonContainer}>
                <Button
                  component={teaserButtonType}
                  to={teaserButtonLink}
                  sx={wbsTeaserWithCardsStyles.startButton}
                  onClick={handleTeaserButtonClick}
                  variant={"contained"}
                >
                  {teaserButtonText}
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
        {children}
      </Container>
    </div>
  );
};

export default WbsTeaserWithCards;
